export default function FacebookSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.881"
      height="20.833"
      viewBox="0 0 10.881 20.833"
    >
      <g data-name="Facebook 1" transform="translate(-1244 -325)">
        <path
          data-name="Path 1 1"
          d="M7.055,20.833V11.345h3.239l.464-3.7h-3.7V5.322c0-1.042.35-1.856,1.856-1.856h1.97V.114C10.417.114,9.261,0,7.983,0A4.466,4.466,0,0,0,3.239,4.858V7.633H0v3.7H3.239v9.5Z"
          transform="translate(1244 325)"
          fill="#0f21d8"
        />
      </g>
    </svg>
  );
}
